export const favorite = {
  add: "お気に入りに追加",
  remove: "お気に入りを解除",
  addedToast: "お気に入りしました",
} as const;
